<div class="flex justify-between mb-4">
  <div class="text-xl text-gray-700 font-bold">
    Solicitação de Compras/Cotação
  </div>
  <!--  @if (checkPermission('criar')) {-->
  <!--  <div class="mr-8">-->
  <!--    <button mat-raised-button class="btn-add" (click)="newPriceQuote()">-->
  <!--      Nova Cotação-->
  <!--    </button>-->
  <!--  </div>-->
  <!--  }-->
</div>

<div>
  <div class="mt-4">
    <!--    @if (checkPermission('pesquisar-paginado')) {-->
    <mat-accordion>
      <mat-expansion-panel>
        <mat-expansion-panel-header>
          <mat-panel-title> Pesquisa </mat-panel-title>
        </mat-expansion-panel-header>
        <div>
          <!--            <form-search-proposal-client-->
          <!--              [search]="inputSearch"-->
          <!--              (responseSearch)="search($event)"-->
          <!--            />-->
          <form-search-quote-request-tg-new
            [search]="inputSearch"
            (responseSearch)="search($event)"
          />
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <!--    }-->

    <div class="mt-6">
      @if (!loading) {
        <div>
          <!--          <table-list-simple-->
          <table-list-tariff
            [dataSource]="itemsList"
            [columns]="columns"
            (viewItinerariesItem)="viewItinerariesEvent($event)"
            (selectItem)="selectItemEvent($event)"
          />
          <!--          @if (itemsList.length > 0) {-->
          <!--            <pagination-->
          <!--              [currentPage]="page"-->
          <!--              [pageSize]="rows"-->
          <!--              [totalRecords]="numberRows"-->
          <!--              (pageChanged)="pageChanged($event)"-->
          <!--            />-->
          <!--          }-->
        </div>
      } @else {
        <div>
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      }
      <div [hidden]="itemsList.length == 0">
        <mat-paginator
          [length]="numberRows"
          [pageSize]="rows"
          [pageIndex]="page - 1"
          [pageSizeOptions]="[5, 10, 20, 30]"
          (page)="pageChanged($event)"
        >
        </mat-paginator>
      </div>
    </div>
  </div>
</div>
